import { useRef } from 'preact/compat';

import { FatalAttraction as FA } from '@vpr/tracking';

import { humanize, translate } from '@vimeo/i18n-runtime';

import LiveBadge from './LiveBadge';
import styles from './PlaylistTrack.module.scss';
import TrackThumbnail from './TrackThumbnail';

const PlaylistTrack = ({ clip, currentLiveViewers = 0, isPlaying, isSelected, switchClip }) => {
  const className = `${styles.playlistTrack} ${isSelected ? styles.selected : ''}`;
  const trackRef = useRef(null);

  return (
    <div
      className={className}
      onClick={() => {
        // Pass offset value so when the tracklist is expanded the selected track is visible.
        const scrollOffset = trackRef.current.offsetTop - trackRef.current.clientHeight;
        switchClip(clip, isPlaying, scrollOffset);
        FA.trackClick({
          container: 'embedded_playlist',
          component: 'video',
        });
      }}
      ref={trackRef}
    >
      <TrackThumbnail isPlaying={isPlaying} isSelected={isSelected} url={clip.thumbnail} />
      <div className={styles.playlistTrackDetails}>
        <div className={styles.playlistTrackClipTitle} title={clip.title}>
          {clip.title}
        </div>
        {clip.isLive ? (
          <div className={styles.playlistTrackLiveDetails}>
            <LiveBadge />
            <span className={styles.playlistTrackLiveViewercount}>
              <svg
                className={styles.playlistTrackLiveViewerIcon}
                viewBox="0 0 20 20"
                width="10"
                height="10"
              >
                <path d="M18 20H2v-4a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5zM10 10a5 5 0 1 1 5-5 5 5 0 0 1-5 5z"></path>
              </svg>
              {currentLiveViewers ? humanize(currentLiveViewers) : 0}
            </span>
          </div>
        ) : (
          <div className={styles.playlistTrackDurationPlays}>
            <span>{clip.duration}</span>
            <span>•</span>
            <span>
              {translate({
                singular: '{playCount} view',
                plural: '{playCount} views',
                count: clip.plays,
                replacements: {
                  playCount: humanize(clip.plays),
                },
              })}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlaylistTrack;
